import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { Flex, HStack, Text, Box, Select } from "@chakra-ui/react";
import { BiChevronDown, BiChevronLeft, BiChevronRight } from "react-icons/bi";
import ListofPendingDisbursementLoans from "./ListofPendingDisbursementLoans";
import { motion } from "framer-motion";

const MotionFlex = motion(Flex);

function PaginatedPendingDisbursement({
  changePage,
  setSearchQuery,
  allLoans,
  pagination,
}) {
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = allLoans.slice(itemOffset, endOffset);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % allLoans.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
    
    setSearchQuery({
      page: event.selected + 1,
      limit: itemsPerPage,
    });

    changePage();
  };

  const totalItems = allLoans?.length || 0;
  const startRange = currentPage * itemsPerPage + 1;
  const endRange = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  return (
    <Box>
      <ListofPendingDisbursementLoans allLoans={currentItems} />
      {allLoans?.length > 0 && (
        <MotionFlex
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          bg="white"
          mt="16px"
          p="12px 24px"
          borderRadius="lg"
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.100"
        >
          <HStack spacing={4}>
            <Select
              icon={<BiChevronDown />}
              bg="gray.50"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="md"
              color="gray.700"
              fontWeight="600"
              fontSize="13px"
              w="110px"
              h="36px"
              cursor="pointer"
              _hover={{ borderColor: "brand.500" }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setItemOffset(0);
                setCurrentPage(0);
              }}
            >
              <option value={10}>10 / page</option>
              <option value={20}>20 / page</option>
              <option value={50}>50 / page</option>
              <option value={100}>100 / page</option>
            </Select>

            <Text
              color="gray.600"
              fontWeight="500"
              fontSize="13px"
            >
              Showing {totalItems > 0 ? `${startRange}-${endRange}` : "0"} of {totalItems} Entries
            </Text>
          </HStack>

          <Box className="pagination-wrapper">
            <ReactPaginate
              breakLabel="..."
              nextLabel={<BiChevronRight size={20} />}
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={Math.ceil(totalItems / itemsPerPage) || 1}
              previousLabel={<BiChevronLeft size={20} />}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item prev"
              previousLinkClassName="page-link"
              nextClassName="page-item next"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              activeClassName="active"
              disabledClassName="disabled"
            />
          </Box>
        </MotionFlex>
      )}
    </Box>
  );
}

export default PaginatedPendingDisbursement;
